<template>
  <div class="ev-page-container">
    <!-- Modal -->
    <modal
      name="edit-daysoff-modal"
      title="Izmena godišnjeg odmora"
      :width="650"
      height="auto"
    >
      <div class="ev-modal-content">
        <div class="ev-modal-employee">
          <span class="ev-modal-label">Zaposleni:</span>
          <span class="ev-modal-value">{{ selectedEmployee.name }}</span>
        </div>
        <dayoffs-quantity-table
          :employeeId="selectedEmployee.id"
          @updateEmployeeId="updateEmployeeId"
        />
      </div>
    </modal>

    <!-- Page Header -->
    <div class="ev-page-header">
      <h1 class="ev-page-title">Godišnji status zaposlenih</h1>
      <p class="ev-page-subtitle">
        Pregled iskorišćenosti godišnjeg odmora po mesecima
      </p>
    </div>

    <!-- Filters Card -->
    <div class="ev-filters-card no-print">
      <h3 class="ev-section-title">
        <span class="ev-section-icon">🔍</span>
        Filteri
      </h3>
      <div class="ev-filters-grid">
        <!-- Year Filter -->
        <div class="ev-filter-group">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">📆</span>
            Godina
          </label>
          <date-picker
            v-model="time3"
            @input="yearChosen"
            type="year"
            class="ev-date-picker"
            placeholder="Izaberite godinu"
          ></date-picker>
        </div>

        <!-- Department Filter -->
        <div class="ev-filter-group">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">🏢</span>
            Sektor
          </label>
          <vue-select
            class="ev-select"
            @option:selected="departmentSelected"
            type="text"
            label="name"
            :clearable="false"
            :options="departments"
            v-model="seletedDepartment"
            placeholder="Izaberite sektor"
          />
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div v-if="isLoading" class="ev-loading-container">
      <div class="ev-spinner"></div>
      <p class="ev-loading-text">Učitavanje podataka...</p>
    </div>

    <!-- Table Section -->
    <div v-if="selectedYear !== 0 && !isLoading" class="ev-table-section">
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-table-icon">📊</span>
          Status za {{ selectedYear }}. godinu
          <span v-if="employees.length > 0" class="ev-table-count">
            {{ employees.length }} zaposlenih
          </span>
        </h3>
      </div>
      <div class="ev-table-container">
        <vue-table-dynamic
          :params="params"
          @cell-dblclick="tableCellDblClicked"
          @row-click="tableRowClicked"
        >
          <template v-slot:column-5="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-6="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-7="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-8="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-9="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-10="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-11="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-12="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-13="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-14="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-15="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
          <template v-slot:column-16="{ props }">
            <span>{{ monthUsedDisplay(props.cellData) }}</span>
            <span
              v-if="monthPlannedDisplay(props.cellData)"
              class="ev-planned-value"
            >
              ({{ monthPlannedDisplay(props.cellData) }})
            </span>
          </template>
        </vue-table-dynamic>
      </div>

      <yearly-status-legend
        :details="selectedRowDetails"
        :employee-id="selectedEmployeeId"
        :year="selectedYear"
        @clear-selection="clearRowSelection"
      />
    </div>

    <!-- Empty State -->
    <div
      v-if="
        selectedYear !== 0 &&
        !isLoading &&
        employees.length === 0 &&
        seletedDepartment
      "
      class="ev-empty-state"
    >
      <span class="ev-empty-icon">📭</span>
      <h3>Nema podataka</h3>
      <p>
        Za izabrani sektor i godinu nema dostupnih podataka o godišnjem odmoru.
      </p>
    </div>
  </div>
</template>

<script>
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic-sum";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { maskIfEquealsValue } from "../../_helpers/arrangers";
import { colors } from "../../_helpers/colors";
import DayoffsQuantityTable from "../parts/DayoffsQuantityTable.vue";
import YearlyStatusLegend from "../parts/YearlyStatusLegend.vue";

export default {
  name: "YearlyStatus",

  components: {
    VueTableDynamic,
    DatePicker,
    DayoffsQuantityTable,
    YearlyStatusLegend,
  },

  data() {
    return {
      //   yearChosen
      time3: null,
      selectedYear: 0,
      // startDate: new Date(),
      // endDate: new Date(),
      seletedDepartment: null,
      isLoading: false,
      params: {
        data: [
          [
            "Ndx",
            "Ime i prezime",
            new Date().getFullYear() - 1 + " do 30.06",
            new Date().getFullYear() - 1 + " 01.07-31.12",
            "Raspoloživo " +
              (new Date().getFullYear() - 1) +
              " / " +
              new Date().getFullYear(),
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAJ",
            "JUN",
            "JUL",
            "AVG",
            "SEP",
            "OKT",
            "NOV",
            "DEC",
            "Potrošeno 2023",
            "Ostalo u " + (new Date().getFullYear() - 1),
            "Ostalo u " + new Date().getFullYear(),
          ],
        ],
        header: "row",
        enableSearch: false,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 45 },
          { column: 2, width: 110 },
          { column: 3, width: 110 },
          { column: 4, width: 100 },
          { column: 5, width: 50 },
          { column: 6, width: 50 },
          { column: 7, width: 50 },
          { column: 8, width: 50 },
          { column: 9, width: 50 },
          { column: 10, width: 50 },
          { column: 11, width: 50 },
          { column: 12, width: 50 },
          { column: 13, width: 50 },
          { column: 14, width: 50 },
          { column: 15, width: 50 },
          { column: 16, width: 50 },
          { column: 17, width: 90 },
          { column: 18, width: 80 },
          { column: 19, width: 80 },
        ],
        wordWrap: "break-word",
        whiteSpace: "normal",
        highlight: { row: [-1] },
        highlightedColor: colors[6],
        sumIncludeInSearch: true,
        sumSecretPhrase: "Σ",
        sumColumns: [
          { column: 2, type: "decimal" },
          { column: 3, type: "decimal" },
          { column: 4, type: "decimal" },
          { column: 5, type: "decimal" },
          { column: 6, type: "decimal" },
          { column: 7, type: "decimal" },
          { column: 8, type: "decimal" },
          { column: 9, type: "decimal" },
          { column: 10, type: "decimal" },
          { column: 11, type: "decimal" },
          { column: 12, type: "decimal" },
          { column: 13, type: "decimal" },
          { column: 14, type: "decimal" },
          { column: 15, type: "decimal" },
          { column: 16, type: "decimal" },
        ],
      },
      employees: [],
      departments: [],
      selectedEmployee: {
        id: 0,
        name: "",
      },
      usedByEmployeeId: {},
      plannedByEmployeeId: {},
      selectedRowIndex: -1,
    };
  },

  computed: {
    selectedEmployeeId() {
      if (this.selectedRowIndex < 1) {
        return 0;
      }
      const employee = this.employees[this.selectedRowIndex - 1];
      return employee ? employee.id : 0;
    },

    selectedRowDetails() {
      if (this.selectedRowIndex < 1) {
        return null;
      }

      const employee = this.employees[this.selectedRowIndex - 1];
      if (!employee) {
        return null;
      }

      const used = this.usedByEmployeeId[employee.id] || {};
      const planned = this.plannedByEmployeeId[employee.id] || {};

      const lastYearFirstHalf = this.toNumber(used.goTotalLastYearFirstHalf);
      const lastYearSecondHalf = this.toNumber(used.goTotalLastYearSecondHalf);
      const availableLastYear = this.toNumber(used.goAvailableLastYear);
      const availableThisYear = this.toNumber(used.goAvailableThisYear);
      const totalAvailable = availableLastYear + availableThisYear;

      const usedSoFar = this.toNumber(used.goTotalThisYear);
      const restLastYear = this.toNumber(used.goRestLastYear);
      const restThisYear = this.toNumber(used.goRestThisYear);

      const plannedTotal =
        this.toNumber(planned.go1) +
        this.toNumber(planned.go2) +
        this.toNumber(planned.go3) +
        this.toNumber(planned.go4) +
        this.toNumber(planned.go5) +
        this.toNumber(planned.go6) +
        this.toNumber(planned.go7) +
        this.toNumber(planned.go8) +
        this.toNumber(planned.go9) +
        this.toNumber(planned.go10) +
        this.toNumber(planned.go11) +
        this.toNumber(planned.go12);

      const usedPlusPlanned = usedSoFar + plannedTotal;
      const projectedRest = totalAvailable - usedPlusPlanned;

      const usedOverage =
        usedSoFar > totalAvailable ? usedSoFar - totalAvailable : 0;
      const plannedOverage =
        usedPlusPlanned > totalAvailable ? usedPlusPlanned - totalAvailable : 0;

      return {
        name: employee.name,
        lastYearFirstHalf,
        lastYearSecondHalf,
        availableLastYear,
        availableThisYear,
        totalAvailable,
        usedSoFar,
        restLastYear,
        restThisYear,
        plannedTotal,
        usedPlusPlanned,
        projectedRest,
        usedOverage,
        plannedOverage,
      };
    },
  },
  mounted() {
    this.time3 = new Date();
    this.yearChosen(this.time3);
    this.getDepartments();
  },
  methods: {
    tableCellDblClicked(row, column, cell, event) {
      console.log("tableCellDblClicked");
      console.log(row);
      console.log(column);
      console.log(cell);
      console.log(event);
      if (column === 4) {
        this.$modal.show("edit-daysoff-modal");
        this.selectedEmployee = this.employees[row - 1];
      }
    },

    tableRowClicked(rowIndex) {
      if (rowIndex < 1 || rowIndex > this.employees.length) {
        this.clearRowSelection();
        return;
      }

      this.selectedRowIndex = rowIndex;
      this.params.highlight = { row: [rowIndex] };
    },

    clearRowSelection() {
      this.selectedRowIndex = -1;
      this.params.highlight = { row: [-1] };
    },
    updateEmployeeId(id) {
      console.log(id);
      this.departmentSelected();
    },
    resetUi() {
      this.clearRowSelection();
      this.usedByEmployeeId = {};
      this.plannedByEmployeeId = {};
      this.params.data = [
        [
          "Ndx",
          "Ime i prezime",
          new Date(this.selectedYear, 1, 1).getFullYear() - 1 + " do 30.06",
          new Date(this.selectedYear, 1, 1).getFullYear() - 1 + " 01.07-31.12",
          "Raspoloživo " +
            (new Date(this.selectedYear, 1, 1).getFullYear() - 1) +
            " / " +
            new Date(this.selectedYear, 1, 1).getFullYear(),
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAJ",
          "JUN",
          "JUL",
          "AVG",
          "SEP",
          "OKT",
          "NOV",
          "DEC",
          "Potrošeno " + new Date(this.selectedYear, 1, 1).getFullYear(),
          "Ostalo u " + (new Date(this.selectedYear, 1, 1).getFullYear() - 1),
          "Ostalo u " + new Date(this.selectedYear, 1, 1).getFullYear(),
        ],
      ];
      this.employees = [];
    },

    yearChosen(year) {
      if (!year || typeof year.getFullYear !== "function") {
        return;
      }

      const previousYear = this.selectedYear;
      this.selectedYear = year.getFullYear();

      if (
        previousYear !== 0 &&
        previousYear !== this.selectedYear &&
        this.seletedDepartment &&
        this.seletedDepartment.id
      ) {
        this.departmentSelected();
      }
    },

    async getDepartments() {
      if (!this.$store.state.general.departments.length) {
        await this.$store.dispatch("general/setDepartmentData");
      }

      this.departments = this.$store.state.general.departments;

      if (!this.seletedDepartment && this.departments.length) {
        this.seletedDepartment = this.departments[0];
        await this.departmentSelected();
      }
    },

    toNumber(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    getMonthViewType(monthNumber) {
      const now = new Date();
      const currentYear = now.getFullYear();

      if (this.selectedYear < currentYear) {
        return "past";
      }

      if (this.selectedYear > currentYear) {
        return "future";
      }

      const currentMonth = now.getMonth() + 1;

      if (monthNumber < currentMonth) {
        return "past";
      }

      if (monthNumber === currentMonth) {
        return "current";
      }

      return "future";
    },

    buildMonthCellValue(usedValue, plannedValue, monthNumber) {
      const viewType = this.getMonthViewType(monthNumber);
      const usedDisplay = maskIfEquealsValue(this.toNumber(usedValue), "0");
      const plannedDisplay = maskIfEquealsValue(
        this.toNumber(plannedValue),
        "0"
      );

      return `${usedDisplay}|${plannedDisplay}|${viewType}`;
    },

    parseMonthCellValue(cellData) {
      const rawValue =
        cellData && typeof cellData === "object" && cellData.value !== undefined
          ? cellData.value
          : cellData;

      if (typeof rawValue !== "string" || rawValue.indexOf("|") === -1) {
        return {
          used: rawValue || "",
          planned: "",
          viewType: "past",
        };
      }

      const [used = "", planned = "", viewType = "past"] = rawValue.split("|");

      return {
        used,
        planned,
        viewType,
      };
    },

    monthUsedDisplay(cellData) {
      const parsed = this.parseMonthCellValue(cellData);

      if (parsed.viewType === "future") {
        return "";
      }

      return parsed.used;
    },

    monthPlannedDisplay(cellData) {
      const parsed = this.parseMonthCellValue(cellData);

      if (parsed.viewType !== "current" && parsed.viewType !== "future") {
        return "";
      }

      return parsed.planned;
    },

    async departmentSelected() {
      if (!this.seletedDepartment || !this.seletedDepartment.id) {
        return;
      }

      this.isLoading = true;

      this.resetUi();

      let departmentId = this.seletedDepartment.id;

      let totalValue = new Array(20).fill(0);

      // load data
      let report = await ReportService.GetYearlyStatusByDepartmentAndYear(
        departmentId,
        this.selectedYear
      );

      console.log("report data: ", report.data);

      const usedGO = Array.isArray(report.data?.usedGO)
        ? report.data.usedGO
        : Array.isArray(report.data)
        ? report.data
        : [];
      const plannedPGO = Array.isArray(report.data?.plannedPGO)
        ? report.data.plannedPGO
        : [];

      const usedByEmployeeId = {};
      const plannedByEmployeeId = {};
      const orderedEmployeeIds = [];

      usedGO.forEach((employee) => {
        usedByEmployeeId[employee.employeeId] = employee;
        orderedEmployeeIds.push(employee.employeeId);
      });

      plannedPGO.forEach((employee) => {
        plannedByEmployeeId[employee.employeeId] = employee;
        if (!orderedEmployeeIds.includes(employee.employeeId)) {
          orderedEmployeeIds.push(employee.employeeId);
        }
      });

      this.usedByEmployeeId = usedByEmployeeId;
      this.plannedByEmployeeId = plannedByEmployeeId;

      let ndx = 0;

      orderedEmployeeIds.forEach((employeeId) => {
        const usedEmp = usedByEmployeeId[employeeId] || {};
        const plannedEmp = plannedByEmployeeId[employeeId] || {};
        const displayEmp = usedEmp.employeeId ? usedEmp : plannedEmp;

        totalValue[0] += this.toNumber(usedEmp.goTotalLastYearFirstHalf);
        totalValue[1] += this.toNumber(usedEmp.goTotalLastYearSecondHalf);
        totalValue[2] += this.toNumber(usedEmp.goAvailableLastYear);
        totalValue[3] += this.toNumber(usedEmp.goAvailableThisYear);
        totalValue[4] += this.toNumber(usedEmp.go1);
        totalValue[5] += this.toNumber(usedEmp.go2);
        totalValue[6] += this.toNumber(usedEmp.go3);
        totalValue[7] += this.toNumber(usedEmp.go4);
        totalValue[8] += this.toNumber(usedEmp.go5);
        totalValue[9] += this.toNumber(usedEmp.go6);
        totalValue[10] += this.toNumber(usedEmp.go7);
        totalValue[11] += this.toNumber(usedEmp.go8);
        totalValue[12] += this.toNumber(usedEmp.go9);
        totalValue[13] += this.toNumber(usedEmp.go10);
        totalValue[14] += this.toNumber(usedEmp.go11);
        totalValue[15] += this.toNumber(usedEmp.go12);
        totalValue[16] += this.toNumber(usedEmp.goTotalThisYear);
        totalValue[17] += this.toNumber(usedEmp.goRestLastYear);
        totalValue[18] += this.toNumber(usedEmp.goRestThisYear);

        this.params.data.push([
          ++ndx,
          (displayEmp.firstName || "") + " " + (displayEmp.lastName || ""),
          maskIfEquealsValue(
            this.toNumber(usedEmp.goTotalLastYearFirstHalf),
            "0"
          ),
          maskIfEquealsValue(
            this.toNumber(usedEmp.goTotalLastYearSecondHalf),
            "0"
          ),
          this.toNumber(usedEmp.goAvailableLastYear) +
            " / " +
            this.toNumber(usedEmp.goAvailableThisYear),
          this.buildMonthCellValue(usedEmp.go1, plannedEmp.go1, 1),
          this.buildMonthCellValue(usedEmp.go2, plannedEmp.go2, 2),
          this.buildMonthCellValue(usedEmp.go3, plannedEmp.go3, 3),
          this.buildMonthCellValue(usedEmp.go4, plannedEmp.go4, 4),
          this.buildMonthCellValue(usedEmp.go5, plannedEmp.go5, 5),
          this.buildMonthCellValue(usedEmp.go6, plannedEmp.go6, 6),
          this.buildMonthCellValue(usedEmp.go7, plannedEmp.go7, 7),
          this.buildMonthCellValue(usedEmp.go8, plannedEmp.go8, 8),
          this.buildMonthCellValue(usedEmp.go9, plannedEmp.go9, 9),
          this.buildMonthCellValue(usedEmp.go10, plannedEmp.go10, 10),
          this.buildMonthCellValue(usedEmp.go11, plannedEmp.go11, 11),
          this.buildMonthCellValue(usedEmp.go12, plannedEmp.go12, 12),
          maskIfEquealsValue(this.toNumber(usedEmp.goTotalThisYear), "0"),
          maskIfEquealsValue(this.toNumber(usedEmp.goRestLastYear), "0"),
          maskIfEquealsValue(this.toNumber(usedEmp.goRestThisYear), "0"),
        ]);

        // track employees
        this.employees.push({
          ndx: ndx,
          id: displayEmp.employeeId,
          name:
            (displayEmp.firstName || "") + " " + (displayEmp.lastName || ""),
        });
      });

      // push last row
      this.params.data.push([
        "",
        "Σ (za vremenski raspon)",
        maskIfEquealsValue(totalValue[0].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[1].toFixed(2), "0.00"),
        totalValue[2] + " / " + totalValue[3],
        maskIfEquealsValue(totalValue[4].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[5].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[6].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[7].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[8].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[9].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[10].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[11].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[12].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[13].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[14].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[15].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[16].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[17].toFixed(2), "0.00"),
        maskIfEquealsValue(totalValue[18].toFixed(2), "0.00"),
      ]);

      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.ev-modal-content {
  padding: 24px;
}

.ev-modal-employee {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background: var(--ev-bg);
  border-radius: var(--ev-radius);
  margin-bottom: 20px;
}

.ev-modal-label {
  font-weight: 600;
  color: var(--ev-text-secondary);
}

.ev-modal-value {
  font-weight: 700;
  color: var(--ev-text-primary);
  font-size: 16px;
}

/* Loading Container */
.ev-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  background: white;
  border-radius: var(--ev-radius-lg);
  box-shadow: var(--ev-shadow);
}

.ev-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--ev-border);
  border-top-color: var(--ev-primary-start);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.ev-loading-text {
  margin-top: 16px;
  font-size: 14px;
  color: var(--ev-text-muted);
  font-weight: 500;
}

/* Table Enhancements */
.ev-table-container {
  overflow-x: auto;
}

.ev-table-container :deep(.v-table) {
  min-width: 1400px;
}

.ev-table-container :deep(.v-table-row) {
  transition: background-color 0.15s ease;
}

.ev-table-container :deep(.v-table-row:hover) {
  background-color: var(--ev-bg-hover) !important;
}

.ev-table-container :deep(.v-table-row.is-header) {
  background: var(--ev-bg) !important;
}

.ev-table-container :deep(.v-table-row.is-header .table-cell) {
  font-weight: 600;
  color: var(--ev-text-secondary);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.ev-table-container :deep(.table-cell) {
  padding: 8px 4px !important;
  font-size: 13px;
  color: var(--ev-text-secondary);
  text-align: center;
}

.ev-planned-value {
  color: #b7791f;
  font-weight: 600;
}

/* Selected row highlight in the table */
.ev-table-container :deep(.v-table-row.is-highlight),
.ev-table-container :deep(.v-table-row.is-highlight .table-cell) {
  background-color: #fefcbf !important;
}

/* Clickable cell hint */
.ev-table-container
  :deep(.v-table-row:not(.is-header) .table-cell:nth-child(5)) {
  cursor: pointer;
  color: var(--ev-info);
  font-weight: 600;
}

.ev-table-container
  :deep(.v-table-row:not(.is-header) .table-cell:nth-child(5):hover) {
  background-color: #eff6ff;
}

/* Date Picker width fix */
.ev-filter-group :deep(.mx-datepicker) {
  width: 100%;
}

/* Print adjustments */
@media print {
  .ev-table-section {
    box-shadow: none;
  }

  .ev-table-header {
    background: var(--ev-bg);
  }

  .ev-table-header .ev-table-title {
    color: var(--ev-text-primary);
  }
}
</style>
